import { watch } from 'vue'
import consumer from './consumer'
import { useSubscriptionStore } from '$/stores/subscription'
import { useNotify } from '$/composables/useNotify'

const subscriptionStore = useSubscriptionStore()
const { pushNotify } = useNotify()

watch(
  () => subscriptionStore.subscription,
  (subscription) => {
    if (!subscription.user_id) return

    consumer.subscriptions.create(
      { channel: 'SubscriptionChannel', user_id: subscription.user_id },
      {
        connected() {
          // console.log('SubscriptionChannel connected!')
        },

        disconnected() {},

        received(data) {
          // Subscription
          if (data.data_type === 'subscription_updated') {
            subscriptionStore.subscription = data.subscription
            if (data.push_notification)
              pushNotify(`${data.subscription.plan_slug.toUpperCase()} plan`, `Subscription updated!`)
            if (window.location.pathname.includes('/change_plan')) window.location.href = '/profile/plan'

            // Credit
          } else if (data.data_type === 'credit_updated') {
            subscriptionStore.credit = data.credit
            if (data.push_notification) pushNotify(`Total credits: ${data.credit.total}`, 'Credits updated!')
          }
        },
      }
    )
  },
  { immediate: true }
)
